<div class="licext-ap" [class.licext-ap--locked]="locked">
  <!-- Region filter + search -->
  <div class="licext-ap__filters">
    <div class="licext-ap__regionrow">
      <span class="licext-ap__filterlbl">Filter by region:</span>
      <div class="licext-ap__region">
        <button
          type="button"
          class="licext-ap__regiontrigger"
          [class.licext-ap__regiontrigger--open]="regionPanelOpen()"
          [disabled]="locked"
          (click)="toggleRegionPanel()">
          <span>{{ regionLabel() }}</span>
          <i class="pi" [class.pi-chevron-down]="!regionPanelOpen()" [class.pi-chevron-up]="regionPanelOpen()"></i>
        </button>

        @if (regionPanelOpen()) {
          <div class="licext-ap__regionpanel">
            <button type="button" class="licext-ap__regionopt" (click)="clearRegions()">
              <span class="licext-ap__box" [class.licext-ap__box--on]="selectedRegions().size === 0">
                @if (selectedRegions().size === 0) { <i class="pi pi-check"></i> }
              </span>
              <span>All regions</span>
            </button>
            @for (r of regions(); track r) {
              <button type="button" class="licext-ap__regionopt" (click)="toggleRegion(r)">
                <span class="licext-ap__box" [class.licext-ap__box--on]="isRegionSelected(r)">
                  @if (isRegionSelected(r)) { <i class="pi pi-check"></i> }
                </span>
                <span>{{ r }}</span>
              </button>
            }
          </div>
        }
      </div>
    </div>

    <input
      type="text"
      class="licext-input licext-ap__search"
      placeholder="Search by name, email or region…"
      [disabled]="locked"
      [ngModel]="query()"
      (focus)="regionPanelOpen.set(false)"
      (ngModelChange)="onSearch($event)" />
  </div>

  <!-- Approver list -->
  <div class="licext-ap__list">
    @for (a of pageItems(); track trackByEmail($index, a)) {
      <label class="licext-ap__row" [class.licext-ap__row--on]="isSelected(a)">
        <input
          type="checkbox"
          [checked]="isSelected(a)"
          [disabled]="locked"
          (change)="toggle(a)" />
        <span class="licext-ap__name">{{ a.name || a.email }}</span>
        <span class="licext-ap__email" [title]="a.email">{{ a.email }}</span>
        <span class="licext-ap__region-tag">{{ a.region }}</span>
      </label>
    } @empty {
      <div class="licext-ap__empty">No approvers match your filters.</div>
    }
  </div>

  <!-- Pagination -->
  @if (totalPages() > 1) {
    <div class="licext-ap__pager">
      <button type="button" class="licext-iconbtn" [disabled]="page() === 0" (click)="prevPage()">
        <i class="pi pi-chevron-left"></i>
      </button>
      <span class="licext-ap__pagenum">{{ page() + 1 }} / {{ totalPages() }}</span>
      <button type="button" class="licext-iconbtn" [disabled]="page() >= totalPages() - 1" (click)="nextPage()">
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
  }

  <!-- Footer: select-all + send -->
  <div class="licext-ap__footer">
    <button
      type="button"
      class="licext-ap__selectall"
      [disabled]="locked || filtered().length === 0"
      (click)="toggleSelectAll()">
      {{ allFilteredSelected() ? 'Deselect all' : 'Select all' }} ({{ filtered().length }})
    </button>

    <button
      type="button"
      class="licext-btn licext-btn--primary"
      [disabled]="locked || selectedCount() === 0"
      (click)="submitSelection()">
      {{ submitLabel }} ({{ selectedCount() }} selected)
    </button>
  </div>
</div>
